export abstract class CommonHeaders extends Headers {
  public readonly apiKey: string;

  public constructor(apiKey: string) {
    super();

    this.apiKey = apiKey;

    this.set('Accept', 'application/json');
    this.set('Content-Type', 'application/json');
  }
}
